var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFeelsLikeWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icFeelsLike") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.8696947,454.355319 C28.343733,454.355319 26.2960364,456.409094 26.2960364,458.942553 L26.2960364,471.557447 C26.2960364,474.090906 28.343733,476.144681 30.8696947,476.144681 L44.0189623,476.144681 C46.544924,476.144681 48.5926206,474.090906 48.5926206,471.557447 L48.5926206,458.942553 C48.5926206,456.409094 46.544924,454.355319 44.0189623,454.355319 L30.8696947,454.355319 Z M30.8696947,453.208511 L44.0189623,453.208511 C47.1764144,453.208511 49.7360352,455.775729 49.7360352,458.942553 L49.7360352,471.557447 C49.7360352,474.724271 47.1764144,477.291489 44.0189623,477.291489 L30.8696947,477.291489 C27.7122426,477.291489 25.1526219,474.724271 25.1526219,471.557447 L25.1526219,458.942553 C25.1526219,455.775729 27.7122426,453.208511 30.8696947,453.208511 Z M37.7584722,458.369149 C38.1612457,458.369149 38.7837138,458.878797 38.7837138,459.279235 L38.4175561,467.652025 C38.4175561,468.052463 38.0880142,468.380094 37.6852407,468.380094 C37.2824672,468.380094 36.9529253,468.052463 36.9529253,467.652025 L36.7698464,459.315638 C36.7698464,458.9152 37.3923145,458.369149 37.7584722,458.369149 Z M37.6852407,470.200266 C38.3077088,470.200266 38.7837138,470.673511 38.7837138,471.292369 C38.7837138,471.911227 38.3077088,472.384472 37.6852407,472.384472 C37.0627726,472.384472 36.5867676,471.911227 36.5867676,471.292369 C36.5867676,470.673511 37.0627726,470.200266 37.6852407,470.200266 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messenger-Inbox---Report-Options",
    transform: "translate(-25.000000, -453.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icFeelsLike",
    fill: "#fff",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFeelsLikeWhite);
export default __webpack_public_path__ + "static/media/icFeelsLikeWhite.3ca9b1596619ebca095961d51216702a.svg";
export { ForwardRef as ReactComponent };